import { ProductCompareCarouselStyles as styles } from "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel";
import getColor from "@insite/mobius/utilities/getColor";
import {
    button,
    buttonIconOnlyCommonStyles,
    removeButtonCompareButtonStyles,
} from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.headerContainer = {
    ...styles.headerContainer,
    gap: 0,
    offsetCss: css`
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px;

        ${mediaQueriesBP.minMD} {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 0;
        }
    `,
};

styles.headerTextGridItem = {
    width: [12, 12, 6, 6, 6],
};

styles.headerText = {
    ...styles.headerText,
    css: css`
        margin: 0;
    `,
};

styles.headerButtonsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
        align-self: flex-end;
    `,
};

styles.carousel = {
    ...styles.carousel,
    mainContainer: {
        ...styles.carousel?.mainContainer,
        offsetCss: css`
            position: relative;
            justify-content: center;
        `,
    },
    prevArrowGridItem: {
        ...styles.carousel?.prevArrowGridItem,
        css: css`
            position: absolute;
            top: 50%;
            left: 0;

            ${mediaQueriesBP.minMD} {
                left: 30%;
            }
        `,
    },
    nextArrowGridItem: {
        ...styles.carousel?.nextArrowGridItem,
        css: css`
            position: absolute;
            top: 50%;
            right: 0;
        `,
    },
    prevArrowButton: {
        ...styles.carousel?.prevArrowButton,
        ...buttonIconOnlyCommonStyles,
    },
    nextArrowButton: {
        ...styles.carousel?.nextArrowButton,
        ...buttonIconOnlyCommonStyles,
    },

    carouselSlide: {
        ...styles.carousel?.carouselSlide,
        css: css`
            display: flex;
        `,
    },

    carouselContentContainer: {
        ...styles.carousel?.carouselContentContainer,
        offsetCss: css`
            row-gap: 24px;
            ${mediaQueriesBP.minMD} {
                row-gap: 40px;
            }
        `,
    },

    carouselSlideInner: {
        ...styles.carousel?.carouselSlideInner,
        css: css`
            border: 1px solid ${getColor(colorStrings.commonBorder)};
            padding: 32px 16px 16px;
            border-radius: 4px;
            margin: 0 8px;
        `,
    },

    carouselContentEmptyCellGridItem: {
        ...styles.carousel?.carouselContentEmptyCellGridItem,
        width: [0, 0, 4, 4, 4],
    },

    carouselCellGridItem: {
        ...styles.carousel?.carouselCellGridItem,
        width: [12, 12, 8, 8, 8],
    },

    carouselWrapper: {
        ...styles.carousel?.carouselWrapper,
        css: css`
            ${mediaQueriesBP.maxSM} {
                max-width: 90%;
                margin: 0 auto;
            }
        `,
    },

    attributeLabelGridItem: {
        ...styles.carousel?.attributeLabelGridItem,
        css: css`
            ${styles.carousel?.attributeLabelGridItem?.css};
            border: 0;
            border-right: 1px solid ${getColor(colorStrings.commonGlobalWhite)};
            padding: 8px 16px;
            font-weight: 700;
            text-align: left;

            &:nth-child(even) {
                background-color: ${getColor(colorStrings.commonGlobalGray04)};
            }
        `,
    },

    attributeValueGridItem: {
        ...styles.carousel?.attributeValueGridItem,
        css: css`
            ${styles.carousel?.attributeValueGridItem?.css};
            border: 0;
            padding: 8px 16px;
            text-align: left;
            &:nth-child(even) {
                background-color: ${getColor(colorStrings.commonGlobalGray04)};
            }
        `,
    },
};

styles.removeProductFromCompareClickable = {
    ...removeButtonCompareButtonStyles,
    css: css`
        ${button.primary.css};
        ${removeButtonCompareButtonStyles.css};
        position: absolute;
        top: 10px;
        right: 16px;
    `,
};
